/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

 export const convertFormatPhone = {
    getFormattedPhoneNum
  }
  
  function getFormattedPhoneNum(input) {
    if(input){
      if (typeof (input) !== 'string') input = input?.toString()
      console.log('input',input)
      if (input.length === 10) {
        return input.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2 - $3");
      } else if (input.length === 11) {
        return input.replace(/(\d{3})(\d{3})(\d{5})/, "($1) $2 - $3");
      }else if (input.length === 12) {
        return input.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "$1-$2-$3-$4");
      } else if (input.length === 9) {
        return input.replace(/(\d{2})(\d{3})(\d{4})/, "($1) $2 - $3");
      }  else if (input.length === 8) {
        return input.replace(/(\d{2})(\d{3})(\d{3})/, "($1) $2 - $3");
      } else {
        return input
      }
    }
   
  } 
  